import React, { useState } from "react";

import { Button } from "ui/components/button";
import DirectusCombobox from "components/directus/combobox";
import client from "directus/src/client";

const AddPlannableForm = ({ onSave, selectedUser, weekStartDate, weekEndDate }) => {
  const [project, setProject] = useState(null);
  const [job, setJob] = useState(null);
  const [milestone, setMilestone] = useState(null);

  const handleSave = () => {
    onSave({ project, job, milestone });
    setProject(null);
    setJob(null);
    setMilestone(null);
  };

  // Custom mapping functions to include additional properties
  const mapJobItem = (item) => ({
    value: item.id,
    label: item.name,
    select: item.name,
    start_date: item.start_date,
    end_date: item.end_date,
    fullItem: item,
  });

  const mapMilestoneItem = (item) => ({
    value: item.id,
    label: item.name,
    select: item.name,
    start_date: item.start_date,
    end_date: item.end_date,
    fullItem: item,
  });

  return (
    <div className="mt-6">
      <div className="font-medium mb-3 text-sm">Add New Row</div>
      <div className="flex items-end gap-4 mb-4">
        <div className="flex-1">
          <DirectusCombobox
            client={client}
            collection="projects"
            placeholder="Project"
            value={project}
            onChange={(val) => {
              setProject(val);
              setJob(null);
              setMilestone(null);
            }}
            filter={{
              status: { _eq: "active" },
              access: {
                employee: { _eq: selectedUser?.id },
                job: { status: { _eq: "in_progress" } },
              },
            }}
            sort={["name"]}
            returnItem={true}
          />
        </div>
        <div className="flex-1">
          <DirectusCombobox
            client={client}
            collection="jobs"
            placeholder="Job"
            value={job}
            onChange={(val) => {
              setJob(val);
              setMilestone(null);
            }}
            filter={{
              project: { _eq: project?.value },
              status: { _eq: "in_progress" },
              _or: [
                {
                  // Employee has a non-employee role on this project/job
                  access: {
                    employee: { _eq: selectedUser?.id },
                    role: { _neq: "employee" },
                  },
                },
                {
                  // Public project
                  project: {
                    status: { _eq: "active" },
                  },
                },
                {
                  // Employee is directly assigned to this job
                  employees: {
                    employee: { _eq: selectedUser?.id },
                  },
                },
              ],
            }}
            fields={["id", "name", "start_date", "end_date"]}
            mapItem={mapJobItem}
            disabled={!project}
            returnItem={true}
          />
        </div>
        <div className="flex-1">
          <DirectusCombobox
            client={client}
            placeholder="Milestone"
            collection="milestones"
            value={milestone}
            onChange={setMilestone}
            filter={{
              job: { _eq: job?.value },
              status: { _eq: "in_progress" },
              _or: [
                {
                  // Milestone overlaps with the planning week
                  start_date: { _lte: weekEndDate },
                  end_date: { _gte: weekStartDate },
                },
                {
                  start_date: { _between: [weekStartDate, weekEndDate] },
                },
                {
                  end_date: { _between: [weekStartDate, weekEndDate] },
                },
              ],
            }}
            fields={["id", "name", "start_date", "end_date"]}
            mapItem={mapMilestoneItem}
            disabled={!job}
            returnItem={true}
          />
        </div>
        <div>
          <Button
            onClick={handleSave}
            disabled={!project || !job}
          >
            Add
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddPlannableForm;
